import React from 'react'
import styled from 'styled-components'
import ClipLoader from 'react-spinners/ClipLoader'
import { STYLES } from '../../static/style'
import { Text } from '../Text'

const StyledSearchResultsLoadingMessage = styled.div`
  margin: ${STYLES.GUTTER};
  padding: ${STYLES.LIST_ITEM_PADDING};
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledClipLoader = styled(ClipLoader).attrs({
  size: 20,
})``

const LoadingText = styled(Text)`
  margin-left: ${STYLES.GUTTER};
`

interface ISearchResultsLoadingMessageProps {
  className?: string
}

const SearchResultsLoadingMessage: React.FC<ISearchResultsLoadingMessageProps> =
  ({ className }) => (
    <StyledSearchResultsLoadingMessage className={className}>
      <StyledClipLoader />
      <LoadingText>Loading...</LoadingText>
    </StyledSearchResultsLoadingMessage>
  )

export { SearchResultsLoadingMessage }
